import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import chinaFlagUrl from '@assets/icons/flags/China.svg'
import indonesiaFlagUrl from '@assets/icons/flags/Indonesia.svg'
import malaysiaFlagUrl from '@assets/icons/flags/Malaysia.svg'
import singaporeFlagUrl from '@assets/icons/flags/Singapore.svg'
import thailandFlagUrl from '@assets/icons/flags/Thailand.svg'
import vietnamFlagUrl from '@assets/icons/flags/Vietnam.svg'
import Chevron from '@components/Chevron/Chevron'
import { INTER } from '@styles/fonts'
import { BLACK, NEUTRAL_100 } from '@styles/colors'
import {
  Container,
  Label,
  InputContainer,
  FormInput,
  CountrySelector,
  ChevronWrapper,
  InputWrapper,
  StyledInput,
  ProviderSection,
  ProviderInfo,
  ProviderPlaceholderOuter,
  ProviderPlaceholderInner,
  ProviderPlaceholder
} from './PhoneInput.styles'
type Nation = 'Indonesia' | 'Singapore' | 'Malaysia' | 'Vietnam' | 'Thailand' | 'China'

type FlagProps = {
  nation: Nation
}

const FlagImg = styled.img``

const Flag = ({ nation }: FlagProps) => {
  switch (nation) {
    case 'Indonesia':
      return <FlagImg src={indonesiaFlagUrl} />
    case 'China':
      return <FlagImg src={chinaFlagUrl} />
    case 'Singapore':
      return <FlagImg src={singaporeFlagUrl} />
    case 'Malaysia':
      return <FlagImg src={malaysiaFlagUrl} />
    case 'Vietnam':
      return <FlagImg src={vietnamFlagUrl} />
    case 'Thailand':
      return <FlagImg src={thailandFlagUrl} />
  }
}

type CountryCodeProps = {
  nation: Nation
}

const Code = styled.span`
  font-family: ${INTER.regular};
  color: ${BLACK};
  font-size: 16px;
`

const CountryCode = ({ nation }: CountryCodeProps) => {
  switch (nation) {
    case 'Indonesia':
      return <Code>+62</Code>
    case 'Singapore':
      return <Code>+65</Code>
    case 'Malaysia':
      return <Code>+60</Code>
    case 'Vietnam':
      return <Code>+84</Code>
    case 'Thailand':
      return <Code>+66</Code>
    case 'China':
      return <Code>+86</Code>
  }
}

type ProviderIconProps = {
  type?: 'credit' | 'data' | 'e-sim',
  url?: string
}

const ProviderImg = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`

const ProviderImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background-color: #F1F3F5;
  border: 1px solid #DEE2E6;
  border-radius: 6px;
  padding: 4px 8px;
  width: 40px;
  height: 28px;
`

type ProviderPlaceholderContainerProps = {
  children: React.ReactNode
}

const ProviderPlaceholderContainer = ({ children }: ProviderPlaceholderContainerProps) => {
  return (
    <ProviderPlaceholderOuter>
      <ProviderPlaceholderInner>
        {children}
      </ProviderPlaceholderInner>
    </ProviderPlaceholderOuter>
  )
}

const ProviderIcon = ({ type = 'credit', url }: ProviderIconProps) => {
  if (url) {
    return (
      <ProviderImageWrapper>
        <ProviderImg src={url} />
      </ProviderImageWrapper>
    )
  } else {
    switch (type) {
      case 'credit':
        return <ProviderPlaceholderContainer>
          <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 6C0 5.05323 0.767512 4.28571 1.71429 4.28571C2.66106 4.28571 3.42857 5.05323 3.42857 6V9.42857C3.42857 10.3753 2.66106 11.1429 1.71429 11.1429C0.767512 11.1429 0 10.3753 0 9.42857V6Z" fill="white" fillOpacity="0.04" />
            <path d="M0 6C0 5.05323 0.767512 4.28571 1.71429 4.28571C2.66106 4.28571 3.42857 5.05323 3.42857 6V9.42857C3.42857 10.3753 2.66106 11.1429 1.71429 11.1429C0.767512 11.1429 0 10.3753 0 9.42857V6Z" fill="black" fillOpacity="0.2" />
            <path d="M5.14286 4.28571C5.14286 3.33894 5.91037 2.57143 6.85714 2.57143C7.80392 2.57143 8.57143 3.33894 8.57143 4.28571V9.42857C8.57143 10.3753 7.80392 11.1429 6.85714 11.1429C5.91037 11.1429 5.14286 10.3753 5.14286 9.42857V4.28571Z" fill="white" fillOpacity="0.04" />
            <path d="M5.14286 4.28571C5.14286 3.33894 5.91037 2.57143 6.85714 2.57143C7.80392 2.57143 8.57143 3.33894 8.57143 4.28571V9.42857C8.57143 10.3753 7.80392 11.1429 6.85714 11.1429C5.91037 11.1429 5.14286 10.3753 5.14286 9.42857V4.28571Z" fill="black" fillOpacity="0.2" />
            <path d="M10.2857 1.71429C10.2857 0.767512 11.0532 0 12 0C12.9468 0 13.7143 0.767512 13.7143 1.71429V9.42857C13.7143 10.3753 12.9468 11.1429 12 11.1429C11.0532 11.1429 10.2857 10.3753 10.2857 9.42857V1.71429Z" fill="white" fillOpacity="0.04" />
            <path d="M10.2857 1.71429C10.2857 0.767512 11.0532 0 12 0C12.9468 0 13.7143 0.767512 13.7143 1.71429V9.42857C13.7143 10.3753 12.9468 11.1429 12 11.1429C11.0532 11.1429 10.2857 10.3753 10.2857 9.42857V1.71429Z" fill="black" fillOpacity="0.2" />
          </svg>
        </ProviderPlaceholderContainer>
      case 'data':
        return <ProviderPlaceholderContainer>
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.68421 2.69782C3.88741 2.41795 4.2176 2.23577 4.58991 2.23577C5.20723 2.23593 5.70737 2.73671 5.70737 3.35407V11.7388C5.70737 12.3562 5.20723 12.857 4.58991 12.8571C3.97244 12.8571 3.4716 12.3563 3.4716 11.7388V5.98912L1.91887 7.58119C1.48661 8.02449 0.775928 8.03276 0.334325 7.59877C-0.104838 7.16717 -0.112296 6.46094 0.317584 6.02009L3.31089 2.95061C3.42037 2.83835 3.54796 2.75409 3.68421 2.69782Z" fill="white" fillOpacity="0.04" />
            <path d="M3.68421 2.69782C3.88741 2.41795 4.2176 2.23577 4.58991 2.23577C5.20723 2.23593 5.70737 2.73671 5.70737 3.35407V11.7388C5.70737 12.3562 5.20723 12.857 4.58991 12.8571C3.97244 12.8571 3.4716 12.3563 3.4716 11.7388V5.98912L1.91887 7.58119C1.48661 8.02449 0.775928 8.03276 0.334325 7.59877C-0.104838 7.16717 -0.112296 6.46094 0.317584 6.02009L3.31089 2.95061C3.42037 2.83835 3.54796 2.75409 3.68421 2.69782Z" fill="black" fillOpacity="0.2" />
            <path d="M6.70849 1.1183C6.70849 0.500843 7.20933 0 7.82679 0C8.44409 0.00018801 8.94426 0.500959 8.94426 1.1183V6.86802L10.497 5.27595C10.9292 4.83268 11.6399 4.82447 12.0815 5.25837C12.5207 5.68997 12.5282 6.3962 12.0983 6.83705L9.10497 9.90653C8.99551 10.0187 8.86787 10.1031 8.73165 10.1593C8.52851 10.4391 8.19892 10.6213 7.82679 10.6214C7.20933 10.6214 6.70849 10.1205 6.70849 9.50307V1.1183Z" fill="white" fillOpacity="0.04" />
            <path d="M6.70849 1.1183C6.70849 0.500843 7.20933 0 7.82679 0C8.44409 0.00018801 8.94426 0.500959 8.94426 1.1183V6.86802L10.497 5.27595C10.9292 4.83268 11.6399 4.82447 12.0815 5.25837C12.5207 5.68997 12.5282 6.3962 12.0983 6.83705L9.10497 9.90653C8.99551 10.0187 8.86787 10.1031 8.73165 10.1593C8.52851 10.4391 8.19892 10.6213 7.82679 10.6214C7.20933 10.6214 6.70849 10.1205 6.70849 9.50307V1.1183Z" fill="black" fillOpacity="0.2" />
          </svg>
        </ProviderPlaceholderContainer>
      case 'e-sim':
        return <ProviderPlaceholderContainer>
          <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.754883" width="19" height="13.9333" rx="3.8" fill="white" fillOpacity="0.04" />
            <rect y="0.754883" width="19" height="13.9333" rx="3.8" fill="black" fillOpacity="0.2" />
            <path d="M15.8333 4.11817C15.8333 3.54957 15.3607 3.08862 14.7778 3.08862H10.0278V7.20679H15.8333V4.11817ZM16.8889 11.325L16.8775 11.5351C16.7768 12.5045 15.9871 13.2747 14.9932 13.373L14.7778 13.384V12.3545C15.3607 12.3545 15.8333 11.8936 15.8333 11.325V8.23633H10.0278V12.3545H14.7778V13.384H4.22222V12.3545H8.97222V3.08862H4.22222C3.63926 3.08862 3.16667 3.54957 3.16667 4.11817V11.325C3.16667 11.8936 3.63926 12.3545 4.22222 12.3545V13.384L4.00678 13.373C3.01292 13.2747 2.22321 12.5045 2.12245 11.5351L2.11111 11.325V4.11817C2.11111 2.98097 3.05629 2.05908 4.22222 2.05908H14.7778C15.9437 2.05908 16.8889 2.98097 16.8889 4.11817V11.325Z" fill="#EFEFEF" />
            <path d="M14.7778 14.4136V15.4431H9.5V14.4136H14.7778ZM17.9444 11.325V4.11817C17.9444 2.41237 16.5267 1.02954 14.7778 1.02954H4.22222C2.47332 1.02954 1.05556 2.41237 1.05556 4.11817V11.325C1.05556 13.0308 2.47332 14.4136 4.22222 14.4136V15.4431L4.00472 15.4381C1.77392 15.3277 0 13.5282 0 11.325V4.11817C0 1.84377 1.89035 0 4.22222 0H14.7778C17.1096 0 19 1.84377 19 4.11817V11.325C19 13.5994 17.1096 15.4431 14.7778 15.4431V14.4136C16.5267 14.4136 17.9444 13.0308 17.9444 11.325ZM9.5 14.4136V15.4431H4.22222V14.4136H9.5Z" fill="#EFEFEF" />
            <path d="M6.33333 15.1986H5.27778V13.1395H6.33333V15.1986Z" fill="#EFEFEF" />
            <path d="M13.7222 15.1986H12.6667V13.1395H13.7222V15.1986Z" fill="#EFEFEF" />
            <path d="M6.33333 2.02153H5.27778V0.664865H6.33333V2.02153Z" fill="#EFEFEF" />
            <path d="M13.7222 2.02153H12.6667V0.664865H13.7222V2.02153Z" fill="#EFEFEF" />
            <path d="M10.0278 2.02153H8.97222V0.664865H10.0278V2.02153Z" fill="#EFEFEF" />
            <path d="M10.0278 15.1986H8.97222V13.1395H10.0278V15.1986Z" fill="#EFEFEF" />
          </svg>
        </ProviderPlaceholderContainer>
    }
  }
}


const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 10;
`

const DropdownItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #F8F9FA;
  }
`

const CountryName = styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${BLACK};
`

const countries: Array<{ nation: Nation; name: string }> = [
  { nation: 'Indonesia', name: 'Indonesia' },
  { nation: 'Singapore', name: 'Singapore' },
  { nation: 'Malaysia', name: 'Malaysia' },
  { nation: 'Vietnam', name: 'Vietnam' },
  { nation: 'Thailand', name: 'Thailand' },
  { nation: 'China', name: 'China' },
]

type PhoneInputProps = {
  value?: string
  onChange?: (value: string) => void
  readOnly?: boolean
  iconType?: 'credit' | 'data' | 'e-sim'
  providerName?: string
  providerImageUrl?: string | null
}

export default function PhoneInput({
  value = '',
  onChange,
  readOnly = false,
  iconType = 'credit',
  providerName,
  providerImageUrl
}: PhoneInputProps) {
  const { t } = useTranslation()
  const [selectedCountry, setSelectedCountry] = useState<Nation>('Indonesia')
  // const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  return (
    <Container>
      <Label>{t('phoneInput.label')}</Label>
      <InputContainer>
        <FormInput>
          <CountrySelector
            // onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <Flag nation={selectedCountry} />
            {/* <ChevronWrapper>
              <Chevron size={6} direction={isDropdownOpen ? 'up' : 'down'} />
            </ChevronWrapper> */}
          </CountrySelector>
          <InputWrapper>
            <CountryCode nation={selectedCountry} />
            <StyledInput
              type='tel'
              value={value}
              onChange={(e) => {
                const numbers = e.target.value.replace(/[^0-9]/g, '').replace(/^0+/, '')
                onChange?.(numbers)
              }}
              readOnly={readOnly}
              $readOnly={readOnly}
              inputMode='none'
            />
          </InputWrapper>
        </FormInput>
        {/* {isDropdownOpen && (
          <DropdownContainer>
            {countries.map(({ nation, name }) => (
              <DropdownItem
                key={nation}
                onClick={() => {
                  setSelectedCountry(nation)
                  setIsDropdownOpen(false)
                }}
              >
                <Flag nation={nation} />
                <CountryName>{name}</CountryName>
                <CountryCode nation={nation} />
              </DropdownItem>
            ))}
          </DropdownContainer>
        )} */}
      </InputContainer>
      <ProviderSection>
        <ProviderInfo>
          <ProviderIcon type={iconType} url={providerImageUrl || undefined} />
          <ProviderPlaceholder>
            {providerName && value ? providerName : t('phoneInput.addPhoneNumber')}
          </ProviderPlaceholder>
        </ProviderInfo>
      </ProviderSection>
    </Container>
  )
}
